import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Category, ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CustomCategoryAdapter } from '../conectors';




@Injectable()
export class CustomOccCategoryAdapter implements CustomCategoryAdapter {

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
  ) {
  }

  load(code: string): Observable<Category> {
    const url = this.occEndpoints.buildUrl('category', { urlParams: { code } });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.get<Category>(url, { headers })
      .pipe(
        catchError((error: any) => throwError(error)),
        map((cateory) => {
          return cateory;
        }
        )
      );
  }
}
